import { Color, FontFamilies, Typography } from '@persona-id/design-tokens';
import { FONT_SIZES, LINE_HEIGHTS, SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

export const UppercaseLabel = styled('h5')`
  ${Typography.TextMediumBold};
  letter-spacing: 1px;
  line-height: ${LINE_HEIGHTS.small};
  margin-bottom: ${SPACINGS.base}px;
  text-transform: uppercase;
`;

export const MonoSpan = styled('span')`
  font-family: ${FontFamilies.Monospace};
  font-size: ${FONT_SIZES.code};
`;

export const TextWithDashedUnderline = styled('span')`
  text-decoration: underline;
  text-decoration-style: dashed;
  text-decoration-color: ${Color.CoreSlate700};
  text-underline-offset: 2px;
  text-decoration-thickness: 1px;
`;
